import React from "react";
import { useNavigate } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import logoAzienda from "../../assets/img/bp-tsAziendaCloud.png";
import logoEnterprise from "../../assets/img/bp-tsEnterprise.png";
import logoContabilita from "../../assets/img/bp-contabilitaInCloud.png";
import logoFattureinCloud from "../../assets/img/bp-fattureInCloud.png";
import businessImage from "../../assets/img/business-landing.svg";
import businessVideo from "../../assets/img/bp-landingVideo.gif";

import "./style.css";
import { Button } from "@ts-digital/vrc";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config";
import { useSelector } from "react-redux";

const LandingNoData = () => {  
  const navigate = useNavigate();
  const main = useSelector(state => state.main);
  const analytics = useSelector(state => state.analytics);

  const linkBack = {
    text: <FormattedMessage id="deadlines.goClientList" />,
    pushUrl: "/scheda-cliente",
    winLocation: null
  };

  // const dboxEndpointForVideo = TSDIGITAL_ENDPOINT.substring(0, TSDIGITAL_ENDPOINT.length - 2);

  return (
    <div className="containerDiv">
      <div className="upperDiv">
        <div
          className="backTo"
          onClick={el => {
            navigate(linkBack.pushUrl);
          }}
        >
          <FontAwesomeIcon icon={["fal", "arrow-left"]} />{" "}
          <span>{linkBack.text}</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="headContainerLanding">
            <div>
              <div className="noDataTitle">
                <FormattedMessage id="customerPage.landing.noDataTitleUp" />
              </div>
              <div className="noDataSub">
                <FormattedMessage id="customerPage.landing.noDataSubTitleUp" />
              </div>
              <div className="buttonPack">
                <a
                  href={
                    TSDIGITAL_PORTALE_PUBLIC_URL +
                    "#/" +
                    main.accountantIdSelected +
                    "/connections/create/existingCompany/" +
                    main.clientIdSelected
                  }
                  id="goToTSDigital"
                  tabIndex="0"
                >
                  {analytics &&
                    analytics.isBusinessPerformanceActive &&
                    analytics.isBusinessPerformanceActive.status.ended &&
                    !analytics.isBusinessPerformanceActive.status.error &&
                    !analytics.isBusinessPerformanceActive.isActive && (
                    <Button style={{ marginRight: "20px" }} kind="secondary">
                      <FormattedMessage id="customerPage.landing.activateBusinessPerformance" />
                    </Button>
                  )}
                </a>
              </div>
            </div>
            <div className="headerVideoContainer">
              <img className="headerVideo" src={businessVideo} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="middleDiv">
        <div className="imgContainer">
          <img src={businessImage} alt="" />
        </div>
        <div className="textContainer">
          <div className="middleTitle">
            <FormattedMessage id="customerPage.landing.titleMiddle" />
          </div>
          <div className="middleSub">
            <FormattedMessage id="customerPage.landing.subTitleMiddle1" />
          </div>
          <div className="middleSub">
            <FormattedMessage id="customerPage.landing.subTitleMiddle2" />
          </div>
          <div className="logosContainer">
            <img
              className="imgLogo"
              src={logoContabilita}
              alt=""
              style={{ maxWidth: 145 }}
            />
            <img className="imgLogo" src={logoFattureinCloud} alt="" />
            <img className="imgLogo" src={logoEnterprise} alt="" />
            <img className="imgLogo" src={logoAzienda} alt="" />
          </div>
        </div>
      </div>
      <div className="bottomDiv">
        <div className="bottomItems">
          <FontAwesomeIcon icon={["far", "users"]} className="iconCss" />{" "}
          <FontAwesomeIcon icon={["far", "chart-bar"]} className="iconCss" />{" "}
          <FontAwesomeIcon icon={["far", "tachometer"]} className="iconCss" />{" "}
        </div>
        <div className="bottomItems">
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.collaborationTitle" />
          </div>
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.graphKpiTitle" />
          </div>
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.newServicesTitle" />
          </div>
        </div>
        <div className="bottomItems">
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.collaborationSub" />
          </div>
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.graphKpiSub" />
          </div>
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.newServicesSub" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingNoData;
